import { IAxiosErrorResponse } from "./interfaces";

const formatRequestUrl = (response: IAxiosErrorResponse): string => {
  const base = String(response.config?.baseURL || "").replace(/\/+$/, "");
  const path = String(response.config?.url || "").replace(/^\/+/, "");
  if (!base) return path || "(unknown url)";
  if (!path) return base;
  return `${base}/${path}`;
};

export const createUrlNotFoundError = (
  response: IAxiosErrorResponse,
): string => `[${response.config?.method}] ${formatRequestUrl(response)} not found`;

export const createUnexpectedError = (
  response: IAxiosErrorResponse,
): string => `Unexpected error from the server: ${response.data?.error || response.data || "Unknown error"}`;

export const createUnauthorizedError = (
  response: IAxiosErrorResponse,
): string => {
  const serverMsg = typeof response.data?.error === "string" ? response.data.error.trim() : "";
  if (serverMsg) {
    return serverMsg;
  }
  return `You have to provide token to make ${response.config?.method} request to ${formatRequestUrl(response)}`;
};

export const createForbiddenError = (
  response: IAxiosErrorResponse,
): string => `You have no rights to access ${formatRequestUrl(response)}`;

export const getError = (response?: IAxiosErrorResponse | null): string => {
  if (!response?.status) {
    return "Network error or CORS blocked. Check that the API allows requests from this origin.";
  }
  switch (response.status) {
    case 401:
      return createUnauthorizedError(response);
    case 403:
      return createForbiddenError(response);
    case 404:
      return createUrlNotFoundError(response);
    case 400:
    case 409:
    case 457:
      return response.data?.error || (response.data as unknown) as string || "Bad request";
    default:
      return createUnexpectedError(response);
  }
};
